import { render } from "./addinventary.vue?vue&type=template&id=17d0ee7f"
import script from "./addinventary.vue?vue&type=script&lang=js"
export * from "./addinventary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__